import { gql } from '@apollo/client';
import useQuery from 'api/hooks/useQuery';
import permissions from 'api/Apollo/permissions';

export const PLAYBOOK_SECRET_CLUSTERS_QUERY = 'PlaybookSecretClusters';

export const query = gql`
  query PlaybookSecretClusters($playbookId: uuid!) {
    playbookSecretClusters: playbook_secret_clusters(where: { playbookId: { _eq: $playbookId } }) {
      playbookId
      clusterId
      createdAt
    }
  }
`;

export default function useQueryPlaybookSecretClusters({ playbookId, ...options } = {}) {
  const { data, loading, error, isAllowed } = useQuery(query, {
    variables: { playbookId },
    skip: !playbookId,
    context: { permission: permissions.readCluster },
    ...options,
  });

  return {
    data: data?.playbookSecretClusters ?? [],
    loading,
    error,
    isAllowed,
  };
}
